jQuery.screenSize = function (size) {
    const sizes = ["xs", "sm", "md", "lg", "container", "xl", "xxl", "mobile"];
    const breakpoints = [0, 480, 768, 1180, 1440, 1600, 1920, 900 ];
    const sizeIndex = sizes.indexOf(size);
    return window.matchMedia(`(min-width: ${breakpoints[sizeIndex]}px)`).matches;
};

jQuery.toScreenSize = function (size) {
    const sizes = ["xs", "sm", "md", "lg", "container", "xl", "xxl", "mobile"];
    const breakpoints = [0, 480, 768, 1180, 1440, 1600, 1920, 900 ];
    const sizeIndex = sizes.indexOf(size);
    return window.matchMedia(`(max-width: ${breakpoints[sizeIndex]}px)`).matches;
};

jQuery.isMobile = function () {
    return window.matchMedia(`(max-width: 900px)`).matches;
};